export const CLIENT_TABS = ['overview', 'journal', 'meetings'] as const

export type ClientTab = (typeof CLIENT_TABS)[number]

export const CLIENT_TAB_LABELS: Record<ClientTab, string> = {
  overview: 'Overview',
  journal: 'Journal',
  meetings: 'Meetings',
}

/** The tab named by a `?tab=` value; anything unknown is the overview. */
export function parseClientTab(raw: string | null): ClientTab {
  return CLIENT_TABS.find((t) => t === raw) ?? 'overview'
}

/** Tabs in display order, leaving out the ones flagged as empty. */
export function visibleClientTabs(
  hidden: Partial<Record<ClientTab, boolean>>
): ClientTab[] {
  return CLIENT_TABS.filter((t) => t === 'overview' || !hidden[t])
}

/** The tab to show: the requested one if visible, else the overview. */
export function resolveClientTab(
  raw: string | null,
  visible: readonly ClientTab[]
): ClientTab {
  const tab = parseClientTab(raw)
  return visible.includes(tab) ? tab : 'overview'
}
